module.exports = __webpack_public_path__ + "static/media/earrings.7060a70e.jpg";